import { pnTokenManager } from '@pn/core/services/authentication/tokenManager';
import type { ApiRequestParams } from '@pn/core/services/http/ports';
import { STACKDX_URL } from '@pn/core/urls';
import { makeRequest } from './apiClient';

// TODO figure out a way to hook this up to IApiClient

export const stackApiClient = {
  request: <T>(params: ApiRequestParams, companyId: string) =>
    makeRequest<T>({
      baseUrl: STACKDX_URL + '/',
      tokenManager: pnTokenManager,
      extraHeaders: {
        'X-Company-Id': companyId,
      },
      params,
    }),
  stream: () => {
    throw new Error('Not implemented');
  },
};
